import Hero from "./hero";
import './Home.css';
import WeddingCountdownTimer from './WeddingCountdownTimer';
import { Container } from 'react-bootstrap';

const Home = () => {
    return (
        <div>
            <Hero />
            <div id="next-section">
                <WeddingCountdownTimer />
                <div class="home text-center container-styling">
                    <Container className="py-5">
                        <h1>Welcome to our virtual wedding hub!</h1>
                        <p>Join us as Nathan, the code-slinging Casanova (who finally finished building this website after what felt like an eternity), and Rebecca, the hard working gynaecologist (who showed incredible patience throughout the process), unite in matrimony. 👰🏻‍♀️🤵🏿‍♂️ We're trading in software bug fixes and speculums for a day of laughter, love, and maybe a few too many inside jokes. 🤭</p>
                        <p>Mark your calendars for <b>1PM 31st May 2025 at Rhyse Farm</b>. We can't wait to celebrate with you—just don't expect us to explain any medical terms or debug your software issues. 😉</p>
                        <p>RSVP by <b>January 31st 2025</b> and let us know if you're joining the party: <a href="/rsvp">RSVP</a></p>
                        <p>Need a place to crash after all the dancing? Check out our accommodation recommendations: <a href="/accommodation">Accommodation</a></p>
                        <p>Want to give us a gift? (We're not that picky!) Find our registry here: <a href="https://prezola.com/buy/view/236139">Gift registry</a></p>
                        <p>Curious about what the day will look like? Check out our order of the day: <a href="/ootd">Order of the day</a></p>
                        <p>For more details about the venue, click here: <a href="/venue">Venue</a></p>
                        <p>Questions? Check out our FAQ page: <a href="/faq">FAQ</a> If you can't find the answers there please don't hesitate to contact either Rebecca or Nathan</p>
                        <p>See you there! 🎉</p>
                    </Container>
                </div>
            </div>
        </div>
    );
}

export default Home;